import React, { createContext, useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import en from "../locals/en.json";
import es from "../locals/es.json";
import Constants from '../locals/constants.json'

export const LanguageContext = createContext();

const translations = { en, es };


export const LanguageProvider = ({ children }) => {
    const { pathname } = useLocation();
    const lang = pathname.split('/')[1];
    const navigate = useNavigate();
    const location = useLocation();
    const Langs = Constants["langs"];
    const [language, setLanguageState] = useState(Langs.find(l => l.value === lang) || Langs[0]);

    useEffect(() => {
        const currentLang = Langs.find(l => l.value === lang);
        console.log(lang);
        if (currentLang && currentLang.value !== language.value) {

            setLanguageState(currentLang);
        }
    }, [lang, language.value, Langs]);

    const setLanguage = (newLangObj) => {
        const newLang = newLangObj.value;
        const currentPath = location.pathname;
        const pathParts = currentPath.split('/').filter(Boolean);

        // Replace the language prefix (first part of the path)
        if (Langs.find(l => l.value === pathParts[0])) {
            pathParts[0] = newLang;
        } else {
            pathParts.unshift(newLang);
        }
        setLanguageState(newLangObj);

        navigate('/' + pathParts.join('/') + location.search + location.hash);
    };

    const t = (value1, value2 = "") =>
        value2 === "" ? translations[language["value"]][value1] || value1 :
            translations[language["value"]][value1][value2] || value2

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    )
}


